var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.45 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#848355;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M27.03,18.92c0-2.98-2.42-5.41-5.41-5.41s-5.41,2.42-5.41,5.41,2.42,5.41,5.41,5.41,5.41-2.42,5.41-5.41Zm-8.11,0c0-1.49,1.21-2.7,2.7-2.7s2.7,1.21,2.7,2.7-1.21,2.7-2.7,2.7-2.7-1.21-2.7-2.7Zm19.65-5.41l-19.64,20.87,1.97,2.09L40.53,15.6l-1.97-2.09Zm20.89,2.95V5.41c0-2.98-2.42-5.41-5.41-5.41H5.41C2.42,0,0,2.42,0,5.41v11.05c3.87,.92,6.76,4.39,6.76,8.54s-2.89,7.62-6.76,8.54v11.07c0,2.98,2.42,5.41,5.41,5.41H54.05c2.98,0,5.41-2.42,5.41-5.41v-11.06c-3.87-.92-6.76-4.39-6.76-8.54,0-4.15,2.89-7.62,6.76-8.54Zm-9.46,8.54c0,4.65,2.77,8.66,6.76,10.46v9.14c0,1.49-1.21,2.7-2.7,2.7H5.41c-1.49,0-2.7-1.21-2.7-2.7v-9.14c3.98-1.8,6.76-5.81,6.76-10.46s-2.77-8.66-6.76-10.46V5.41c0-1.49,1.21-2.7,2.7-2.7H54.05c1.49,0,2.7,1.21,2.7,2.7V14.54c-3.98,1.8-6.75,5.81-6.75,10.46Zm-12.16,.67c-2.98,0-5.41,2.42-5.41,5.41s2.42,5.41,5.41,5.41,5.41-2.42,5.41-5.41c0-2.98-2.42-5.41-5.41-5.41Zm0,8.11c-1.49,0-2.7-1.21-2.7-2.7s1.21-2.7,2.7-2.7,2.7,1.21,2.7,2.7c0,1.49-1.21,2.7-2.7,2.7Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketDetails);
export default __webpack_public_path__ + "static/media/Ticket Details.e852647051250c1c02694685a5b25ebb.svg";
export { ForwardRef as ReactComponent };